module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-container"
  }, [(_vm.searchResult.length > _vm.pageSize) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "result-table",
      "data": _vm.tableData,
      "border": "",
      "element-loading-text": "Loading...."
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "personaname",
      "label": "Name",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "search-result-wrapper"
        }, [_c('img', {
          directives: [{
            name: "lazy",
            rawName: "v-lazy",
            value: (scope.row.avatarfull),
            expression: "scope.row.avatarfull"
          }],
          attrs: {
            "alt": ""
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.personaname))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_match_time",
      "label": "Last match time",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n         " + _vm._s(scope.row.last_match_time ? (scope.row.last_match_time).slice(0, -5).replace(/T|Z/g, ' ') : '') + "\n       ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.viewUserProfile(scope.$index, _vm.tableData)
            }
          }
        }, [_vm._v("\n         View\n       ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.searchResult.length > _vm.pageSize) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71beaaf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchResult.vue
// module id = 143
// module chunks = 1